import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // Invoice status labels
  invoiceStatusOpen: {
    id: 'customerInvoices.status.open',
    defaultMessage: 'Offen',
    description: 'Label for open/unpaid invoice status',
  },
  invoiceStatusPaid: {
    id: 'customerInvoices.status.paid',
    defaultMessage: 'Erledigt',
    description: 'Label for paid invoice status',
  },

  // Tab labels
  tabOpen: {
    id: 'customerInvoices.tab.open',
    defaultMessage: 'Offen',
    description: 'Tab label for open invoices',
  },
  tabAll: {
    id: 'customerInvoices.tab.all',
    defaultMessage: 'Alle',
    description: 'Tab label for all invoices',
  },

  // Filter labels
  timeRangeLabel: {
    id: 'customerInvoices.filter.timeRange',
    defaultMessage: 'Zeitraum:',
    description: 'Label for time range filter',
  },
  filterDescription: {
    id: 'customerInvoices.filter.description',
    defaultMessage: 'Schneller einen besseren Überblick bekommen:',
    description: 'Description text above filters',
  },

  // Invoice card labels
  invoiceTitle: {
    id: 'customerInvoices.invoice.title',
    defaultMessage: 'Rechnung',
    description: 'Invoice card title',
  },
  invoiceFromDate: {
    id: 'customerInvoices.invoice.fromDate',
    defaultMessage: 'vom {date}',
    description: 'Invoice creation date label',
  },
  dueDateLabel: {
    id: 'customerInvoices.invoice.dueDate',
    defaultMessage: 'Fällig am: {date}',
    description: 'Invoice due date label',
  },
  viewInvoiceLabel: {
    id: 'customerInvoices.invoice.viewLabel',
    defaultMessage: 'Rechnung Nr. {invoiceNumber} ansehen',
    description: 'View invoice button label',
  },
  moreProductsLabel: {
    id: 'customerInvoices.invoice.moreProducts',
    defaultMessage: '+{count} Artikel',
    description: 'Label showing additional products count',
  },

  // Load more button
  loadMoreButton: {
    id: 'customerInvoices.loadMore.button',
    defaultMessage: 'Weitere Rechnungen laden',
    description: 'Load more invoices button text',
  },

  // Error messages
  errorMessage: {
    id: 'customerInvoices.error.general',
    defaultMessage: 'Es ist leider ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    description: 'General error message when loading invoices fails',
  },

  // Paylink labels (GALAXY-241)
  paylinkButton: {
    id: 'customerInvoices.invoice.paylinkButton',
    defaultMessage: 'Zahloption wählen und Betrag begleichen',
    description: 'Button text for online payment via paylink',
  },
  paylinkAriaLabel: {
    id: 'customerInvoices.invoice.paylinkAriaLabel',
    defaultMessage: 'Rechnung {invoiceNumber} jetzt bezahlen',
    description: 'Accessible label for paylink button',
  },
});
